(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[501],{

/***/ 5419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useContactAction; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _services_nodeApiService__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9885);
/* harmony import */ var _services_WindowService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2480);



const useContactAction = (gallery)=>{
    const recaptchaRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    const [form, setForm] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        email: "",
        firstname: "",
        lastname: "",
        body: "",
        phone: ""
    });
    const [error, setError] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const [errorMessage, setErrorMessage] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
    const [success, setSuccess] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const [modal, setModal] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const onSubmit = (event)=>{
        event.preventDefault();
        setLoading(true);
        recaptchaRef.current.execute();
    };
    const onReCAPTCHAChange = async (captchaCode)=>{
        if (!captchaCode) {
            return;
        }
        setError(false);
        const service = gallery ? _services_nodeApiService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].contactGallery */ .Z.contactGallery(gallery.id, {
            ...form,
            captcha: captchaCode,
            channel: "discover",
            type: "contact_discover"
        }) : _services_nodeApiService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].contact */ .Z.contact({
            ...form,
            captcha: captchaCode
        });
        service.then((_response)=>{
            console.log(_response);
            formCallback();
        }, (res)=>{
            setError(true);
            setErrorMessage(res.response.data.errorMessage);
            _services_WindowService__WEBPACK_IMPORTED_MODULE_2__/* ["default"].animatedScrollTop */ .Z.animatedScrollTop();
            setLoading(false);
        });
        recaptchaRef.current.reset();
    };
    const formCallback = ()=>{
        _services_WindowService__WEBPACK_IMPORTED_MODULE_2__/* ["default"].animatedScrollTop */ .Z.animatedScrollTop();
        setSuccess(true);
        setLoading(false);
        setForm({
            email: "",
            firstname: "",
            lastname: "",
            body: "",
            phone: ""
        });
    };
    const handleClose = ()=>{
        setModal(false);
        setTimeout(()=>{
            setSuccess(false);
        }, 500);
    };
    const handleShow = ()=>{
        setSuccess(false);
        setModal(true);
    };
    return {
        error,
        errorMessage,
        form,
        setForm,
        modal,
        handleClose,
        handleShow,
        onSubmit,
        success,
        onReCAPTCHAChange,
        recaptchaRef,
        loading
    };
};


/***/ }),

/***/ 7538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ GalleryContactModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4051);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1555);
/* harmony import */ var react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4835);
/* harmony import */ var react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6986);
/* harmony import */ var _Layout_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(158);
/* harmony import */ var _GalleryContactModal_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(370);
/* harmony import */ var _GalleryContactModal_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_GalleryContactModal_module_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4853);









const GalleryContactModal = (param)=>{
    let { modal , handleClose , onSubmit , galleryDetails , setForm , form , error , errorMessage , success , onReCAPTCHAChange , recaptchaRef  } = param;
    const innerRef = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createRef();
    react__WEBPACK_IMPORTED_MODULE_2__.useEffect(()=>{
        setTimeout(()=>{
            var _innerRef_current;
            (_innerRef_current = innerRef.current) === null || _innerRef_current === void 0 ? void 0 : _innerRef_current.focus();
        }, 1);
    }, [
        modal
    ]);
    const contactTitle = "Contact ".concat(galleryDetails && galleryDetails.name || "Us");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        show: modal,
        onHide: handleClose,
        className: (_GalleryContactModal_module_css__WEBPACK_IMPORTED_MODULE_6___default()["modal-content"]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Header */ .Z.Header, {
                className: (_GalleryContactModal_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal),
                closeButton: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Body */ .Z.Body, {
                closeButton: true,
                children: success ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mx-4 px-2 mb-4 w-100 text-center alert",
                        children: [
                            "Your message has been sent. We’ll get back to you soon.",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            "Thank you!"
                        ]
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mx-4 px-2",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "text-black mb-3 fs-24px",
                                children: contactTitle
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                className: "mx-4 px-2",
                                onSubmit: onSubmit,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Group */ .Z.Group, {
                                        controlId: "email",
                                        className: "mb-2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Label */ .Z.Label, {
                                                className: "text-capitalize fs-14px text-black",
                                                children: "Email*"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Control */ .Z.Control, {
                                                className: (_GalleryContactModal_module_css__WEBPACK_IMPORTED_MODULE_6___default().inputFontSize),
                                                type: "email",
                                                onChange: (event)=>{
                                                    setForm({
                                                        ...form,
                                                        email: event.target.value
                                                    });
                                                },
                                                value: form.email,
                                                autoFocus: true,
                                                ref: innerRef
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Group */ .Z.Group, {
                                                as: react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z,
                                                controlId: "firstName",
                                                className: "mb-2 pr-2 pl-3",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Label */ .Z.Label, {
                                                        className: "text-capitalize text-black fs-14px",
                                                        children: "First Name*"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Control */ .Z.Control, {
                                                        className: "input-font-size",
                                                        type: "name",
                                                        onChange: (event)=>{
                                                            setForm({
                                                                ...form,
                                                                firstname: event.target.value
                                                            });
                                                        },
                                                        value: form.firstname
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Group */ .Z.Group, {
                                                as: react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z,
                                                controlId: "lastName",
                                                className: "mb-2 pl-2 pr-3",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Label */ .Z.Label, {
                                                        className: "text-capitalize text-black fs-14px",
                                                        children: "Last Name*"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Control */ .Z.Control, {
                                                        className: "input-font-size",
                                                        type: "name",
                                                        onChange: (event)=>{
                                                            setForm({
                                                                ...form,
                                                                lastname: event.target.value
                                                            });
                                                        },
                                                        value: form.lastname
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Group */ .Z.Group, {
                                        controlId: "message",
                                        className: "mb-2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Label */ .Z.Label, {
                                                className: "text-capitalize fs-14px text-black",
                                                children: "Message*"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Control */ .Z.Control, {
                                                className: (_GalleryContactModal_module_css__WEBPACK_IMPORTED_MODULE_6___default().inputFontSize),
                                                as: "textarea",
                                                rows: "3",
                                                onChange: (event)=>{
                                                    setForm({
                                                        ...form,
                                                        body: event.target.value
                                                    });
                                                },
                                                value: form.body
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Group */ .Z.Group, {
                                        controlId: "phone",
                                        className: "mb-2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Label */ .Z.Label, {
                                                className: "text-capitalize fs-14px text-black",
                                                children: [
                                                    "Phone Number",
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "color-gray-super-light fs-12px",
                                                        children: "(Numbers Only)"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Control */ .Z.Control, {
                                                className: (_GalleryContactModal_module_css__WEBPACK_IMPORTED_MODULE_6___default().inputFontSize),
                                                type: "number",
                                                onChange: (event)=>{
                                                    setForm({
                                                        ...form,
                                                        phone: event.target.value
                                                    });
                                                },
                                                value: form.phone
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        ref: recaptchaRef,
                                        size: "invisible",
                                        sitekey: "6LeDv1IaAAAAABVo8NAoSR50zN8nU1OgpZFBzyOO",
                                        onChange: onReCAPTCHAChange
                                    }),
                                    error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-100 alert alert-danger",
                                        children: errorMessage.map((error)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                children: [
                                                    error,
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                                                ]
                                            }))
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Layout_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        type: "submit",
                                        children: "SUBMIT"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Button_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4425);
/* harmony import */ var _Button_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Button_module_css__WEBPACK_IMPORTED_MODULE_3__);




const Button = (param)=>{
    let { name , children , isAppleButton , isAndroidButton , type ="button" , onClick =()=>{} , size ="lg" , width , disabled =false , variant ="dark" , sx  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Button_module_css__WEBPACK_IMPORTED_MODULE_3___default()["button-container"]), "cursor-pointer", isAppleButton ? (_Button_module_css__WEBPACK_IMPORTED_MODULE_3___default().apple) : isAndroidButton ? (_Button_module_css__WEBPACK_IMPORTED_MODULE_3___default().android) : "", sx),
        style: {
            width: width ? width : "auto"
        },
        onClick: ()=>onClick(),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            disabled: disabled,
            type: type,
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("btn-".concat(size, " btn-sm btn-block btn-").concat(variant, " fw-700 fs-12px ").concat((_Button_module_css__WEBPACK_IMPORTED_MODULE_3___default().button))),
            children: name || children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 1286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const Container = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "container",
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Container);


/***/ }),

/***/ 6470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ HelmetTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



const HelmetTitle = (param)=>/*#__PURE__*/ {
    let { title , hide =false  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
            children: "".concat(title).concat(hide ? "" : " | Discover ArtPlacer")
        })
    });
};


/***/ }),

/***/ 7182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ SeoTags; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



const SeoTags = (param)=>{
    let { description , title , image ="https://artplacer-nextjs.herokuapp.com/artplacer-logo.png" , url , canonical  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                httpEquiv: "X-UA-Compatible",
                content: "IE=edge,chrome=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "ArtPlacer"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "ArtPlacer"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            canonical && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonical
            })
        ]
    });
};


/***/ }),

/***/ 1350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _providers_AppProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2674);



const Wrapper = (param)=>{
    let { children  } = param;
    const profile = (0,_providers_AppProvider__WEBPACK_IMPORTED_MODULE_2__/* .useAppContext */ .b)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "content-wrap".concat(profile.embedded ? " embedded" : ""),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Wrapper);


/***/ }),

/***/ 9885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ services_nodeApiService; }
});

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./config/axiosNodeClient.js

const client = axios_default().create({
    baseURL: "https://discover.artplacer.com/api/"
});
client.interceptors.request.use((request)=>{
    console.log("Starting Request", "".concat(request.baseURL).concat(request.url));
    return request;
});
const axiosNodeClient = client;

;// CONCATENATED MODULE: ./services/nodeApiService.js

const nodeApiService = ()=>({
        artworks: (params)=>{
            return axiosNodeClient.get("artworks", {
                params
            });
        },
        galleryArtworks: (id, params)=>{
            return axiosNodeClient.get("galleries/".concat(id, "/artworks"), {
                params
            });
        },
        galleryArtworksByCollection: function(id, collection_slug) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return axiosNodeClient.get("galleries/".concat(id, "/collections/").concat(encodeURIComponent(collection_slug)), {
                params
            });
        },
        gallery: (id)=>axiosNodeClient.get("galleries/".concat(id)),
        galleries: (params)=>{
            return axiosNodeClient.get("galleries", {
                params
            });
        },
        search: (params)=>{
            return axiosNodeClient.get("search", {
                params
            });
        },
        spaces: (params)=>{
            return axiosNodeClient.get("spaces", {
                params
            });
        },
        contact: (body)=>{
            return axiosNodeClient.post("contact", body);
        },
        dataCapture: (galleryId, body)=>{
            return axiosNodeClient.post("galleries/".concat(galleryId, "/datacapture"), body);
        },
        contactGallery: (galleryId, body)=>{
            return axiosNodeClient.post("galleries/".concat(galleryId, "/contact"), body);
        },
        inquire: (artworkId, body)=>{
            return axiosNodeClient.post("artworks/".concat(artworkId, "/inquire"), body);
        },
        purchase: (artworkId, body)=>{
            return axiosNodeClient.post("artworks/".concat(artworkId, "/purchase"), body);
        },
        exhibitions: (params)=>{
            return axiosNodeClient.get("exhibitions", {
                params
            });
        }
    });
/* harmony default export */ var services_nodeApiService = (nodeApiService());


/***/ }),

/***/ 731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ getArtworkSize; }
/* harmony export */ });
const getArtworkSize = (width, height)=>{
    const w = width && parseFloat(width) !== 0 ? parseFloat(width) + '" W' : "";
    const h = parseFloat(height) + '" H';
    return w ? h + " x " + w : h;
};


/***/ }),

/***/ 3992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ imageResizer; }
/* harmony export */ });
const imageResizer = (image, width, height)=>{
    if (!image) {
        return null;
    }
    const splittedImage = image.split("/");
    splittedImage.splice(splittedImage.length - 1, 0, "".concat(width, "x").concat(height));
    return splittedImage.join("/");
};


/***/ }),

/***/ 3372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ linksBuilder; }
/* harmony export */ });
/* harmony import */ var _slugify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3384);

const linksBuilder = {
    artworks: (id, str)=>"/artworks/".concat(id, "-").concat((0,_slugify__WEBPACK_IMPORTED_MODULE_0__/* .slugify */ .l)(str)),
    galleries: (str)=>"/galleries/".concat(str),
    collections: (id, collection)=>"/galleries/".concat(id, "/collections/").concat((0,_slugify__WEBPACK_IMPORTED_MODULE_0__/* .slugifyCollection */ .b)(collection))
};


/***/ }),

/***/ 3384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ slugifyCollection; },
/* harmony export */   "l": function() { return /* binding */ slugify; }
/* harmony export */ });
const slugify = (str)=>str.toLowerCase().replace(/ /g, "-").replace(/[^\w-]+/g, "");
const slugifyCollection = (str)=>encodeURIComponent(str.toLowerCase());


/***/ }),

/***/ 370:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal":"GalleryContactModal_modal__hnbDg","submit":"GalleryContactModal_submit__zmUwA"};

/***/ }),

/***/ 4425:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button-container":"Button_button-container__qEZ80","button":"Button_button__C97FB","android":"Button_android__22fHr","apple":"Button_apple__tbbth"};

/***/ })

}]);